<template>
  <tr class="m-table-header-row">
    <slot />
    <th class="m-table-header m-table-header_indicator_row">
      <div id="m-table-header-lazy-resize-indicator" />
    </th>
  </tr>
</template>

<script>
  export default {
    name: 'MTableHeaderRow',
    props: {

    }
  };
</script>

<style>
  .m-table-header_indicator_row {
    /* sticky table columns have 20 */
    z-index: 21;
  }

  #m-table-header-lazy-resize-indicator {
    position: absolute;
    display: none;
    top: 0;

    background: var(--action-secondary-color);
  }
</style>
